<footer class="w-full bg-gray-200 max-h-fit">
  <div class="relative container mx-auto p-4 flex flex-col items-center text-center gap-4 pt-8 pb-8">
    <div class="basis-1/3 mt-3 text-gray-700 text-lg">
      Hai un'attività? <a href={{link}} class="font-bold">Prova LetsCard.</a>
    </div>
    <div class="flex basis-1/3">
      <app-logo class="h-10 fill-gray-700" [target]="lookupTarget"></app-logo>
    </div>
    <div class="basis-1/5 mt-3 text-sm leading-relaxed">
      <p>LetsCard è un servizio fornito da <a href="https://www.letvar.io" target="_blank"><span class="font-bold">letvar</span></a>.<br/>
      &copy; {{year}} letvar. Tutti i diritti riservati.</p>
      <p class="pt-4"><span class="font-bold">letvar srl</span><br/>
        COE/VAT ID SM30688 - Via Ventotto Luglio 99 - 47893 Borgo Maggiore (SMR)
      </p>
    </div>
  </div>
</footer>